/* eslint-disable @typescript-eslint/no-explicit-any */

export const getUrlFromMenuItem = (item: any) => {
  if (item.page) {
    return `/${item.page?.slug}`
  }

  if (item.collection) {
    return `/${item.collection?.slug}`
  }

  if (item.category) {
    return `/${item.category?.slug}`
  }

  if (item.url) {
    return item.url
  }

  return '#'
}